// Convierte int a CSS rgb
export function intToCssColor(colorInt) {
  const a = 255;
  const b = (colorInt >> 16) & 0xff;
  const g = (colorInt >> 8) & 0xff;
  const r = colorInt & 0xff;
  return `rgb(${r}, ${g}, ${b}, ${a.toFixed(2)})`;
}

